import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../../axios";
import { Helmet } from "react-helmet";
import moment from "moment";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./Update.module.css";

import FormikControl from "../../../components/FormikControl/FormikControl";
import Button from "../../../components/Button/Button";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";

class Update extends Component {
  state = {
    data: null,
    isLoading: false,
  };

  componentDidMount() {
    this.fetchStatement();
  }

  fetchStatement = () => {
    const { id } = this.props.match.params;

    axios
      .get(`/statement-requests/${id}`)
      .then((response) => {
        this.setState({
          data: {
            ...response.data,
          },
        });
      })
      .catch((error) => {
        if (error.response.data.code === 2001) {
          const errors = error.response.data.errors;
          toast.error(Object.values(errors[0])[0]);
        } else {
          toast.error(error.response.data.message);
        }
      });
  };

  render() {
    const { data } = this.state;

    const initialValues = {
      statement: "",
    };

    const validationSchema = Yup.object({
      statement: Yup.mixed().required("Statement is required"),
    });

    const onSubmit = (values) => {
      this.setState({ isLoading: true });

      const formData = new FormData();
      formData.append("statement", values.statement);

      axios
        .put(`/statement-requests/${data.id}`, formData)
        .then((response) => {
          toast.success(response.data.message);
          this.setState((prevState) => ({
            formId: prevState.formId + 1,
          }));
        })
        .catch((error) => {
          if (error.response.data.code === 2001) {
            const errors = error.response.data.errors;
            toast.error(Object.values(errors[0])[0]);
          } else {
            toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    };

    return (
      <div className={styles.Create}>
        <Helmet>
          <title>Edit | Statement Requests | Lara Capital</title>
        </Helmet>
        <div className="PageHeader">
          <div className="ContentLeft">
            <div className="Title">
              <h1>Statement Requests</h1>
            </div>
            <Breadcrumb>
              <li>
                <Link to="/">Dashboard</Link>
              </li>
              <li>
                <Link to="/statement-requests">Statement Requests</Link>
              </li>
              <li>Send Statement</li>
            </Breadcrumb>
          </div>
        </div>
        <div className="PageContent DataForm">
          <div className="ContentHeader">
            <div className="Title">
              <h1>Send Statement</h1>
            </div>
          </div>
          <div className="MainContent">
            <div className="FormContainer">
              {data ? (
                <>
                  <div className={styles.DetailOverview}>
                    <div className={styles.Detail}>
                      <div>REF ID</div>
                      <div>{data.ref_id}</div>
                    </div>
                    <div className={styles.Detail}>
                      <div>User Name</div>
                      <div>{data.user.name}</div>
                    </div>
                    <div className={styles.Detail}>
                      <div>User ID</div>
                      <div>{data.user.user_id}</div>
                    </div>
                    <div className={styles.Detail}>
                      <div>Status</div>
                      <div>{data.status.name}</div>
                    </div>
                    <div className={styles.Detail}>
                      <div>Requested At</div>
                      <div>
                        {moment(data.created_at).format("DD MMM YYYY, h:mm A")}
                      </div>
                    </div>
                    <div className={styles.Detail}>
                      <div>Updated At</div>
                      <div>
                        {data.updated_at
                          ? moment(data.updated_at).format(
                              "DD MMM YYYY, h:mm A"
                            )
                          : null}
                      </div>
                    </div>
                  </div>
                  <Formik
                    key={this.state.formId}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                  >
                    {({ setFieldValue }) => {
                      return (
                        <Form>
                          <div
                            className={["FormBody", styles.FormBody].join(" ")}
                          >
                            <FormikControl
                              control="fileInput"
                              label="Statement *"
                              name="statement"
                              accept=".pdf"
                              setFieldValue={setFieldValue}
                              fileFormats="PDF"
                              maxFileSize="10MB"
                              value=""
                            />
                          </div>

                          <div
                            className={["FormActions", styles.FormActions].join(
                              " "
                            )}
                          >
                            <Button
                              btnType="Primary"
                              type="Submit"
                              width="W100"
                              isLoading={this.state.isLoading}
                            >
                              Send
                            </Button>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </>
              ) : null}
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

export default Update;
